//import vuex
import { createStore } from 'vuex'
import helper from './helpers/helper'
import accredible from './module/accredible'
import aktifitas from './module/aktifitas'
import auth from './module/auth'
import blog from './module/blog'
import dashboard from './module/dashboard'
import master from './module/master'
import partnership from './module/partnership'
import promo from './module/promo'
import profile from './module/profile'
import reseller from './module/reseller'
import sertifikat from './module/sertifikat'
import trainer from './module/trainer'
import transaksi from './module/transaksi'
import user from './module/user'
import webinar from './module/webinar'
import workshop from './module/workshop'
import quiz from './module/quiz'

//create store vuex
export default createStore({
  modules: {
    accredible,
    aktifitas,
    auth,
    blog,
    dashboard,
    master,
    partnership,
    profile,
    promo,
    reseller,
    sertifikat,
    trainer,
    transaksi,
    user,
    webinar,
    workshop,
    quiz,
    helper,
  },
})
